var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._l((_vm.rating),function(star){return [(star === 'full')?_c('span',{staticClass:"profile__star profile__star--full fa-solid fa-star"}):(star === 'half')?_c('span',{staticClass:"profile__star profile__star--half fa-duotone fa-star-half"}):_c('span',{staticClass:"profile__star profile__star--empty fa-duotone fa-star"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }